import React from 'react';
import PropTypes from "prop-types";

import moment from 'moment';

import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions';


// react component for creating dynamic tables
import ReactTable from 'react-table';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";

// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import {
  Container,
  Row,
  Col,
  Modal
} from 'reactstrap';

import UserProfile from "views/Pages/UserProfile.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import { reactTableDefaultProps } from 'helpers/reactTable';
import { fromE164 } from "helpers/phoneNumber";

import { USER_STATUS, USER_STATUS_STRING } from "constants/user";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    fontWeight: "bold"
  }
};

const modalCustomStyles = {
  content: {
    top: '10%',
    left: '10%',
    // right: '30%',
    bottom: '10%',
    backgroundColor: 'transparent',
    borderWidth: '0px',
    // marginRight: '-20%',
    // transform: 'translate(-20%, -20%)',
  },
  overlay: {
    zIndex: 10,
    backgroundColor: 'rgba(128,128,128,0.4)',
  }
};

class UserManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe = this.props.getUsersAction();
    this.props.getOrgsAction();

  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  afterOpenModal = () => { }
  openModal = () => this.setState({ modalIsOpen: true });
  closeModal = () => this.setState({
    modalIsOpen: false,
    selectedUserId: null
  });
  requestClose = () => { this.closeModal() }

  renderModal = () => {
    return <Modal
      size='lg'
      isOpen={this.state.modalIsOpen}
      toggle={this.requestClose}
    >
      <UserProfile
        user_id={this.state.selectedUserId}
        isEdit={this.state.isEdit}
        requestClose={this.requestClose}
      />
    </Modal>
  }

  render() {
    const { classes } = this.props;
    return (
      <Container>
        <Row>
          <Col>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>사용자 관리</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col className='text-right'>
                    <Button
                      color="primary"
                      onClick={() => {
                        this.setState({
                          uid: null,
                          isEdit: false
                        }, () => this.openModal());
                      }}>신규 유저 등록</Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <ReactTable
                      {...reactTableDefaultProps}
                      data={this.props.users}
                      columns={[
                        {
                          id: 'name',
                          Header: "이름",
                          headerStyle: { textAlign: "center" },
                          accessor: d => d.data().name
                        },
                        {
                          id: 'gender',
                          Header: "성별",
                          width: 100,
                          accessor: d => d.data().gender !== undefined
                            ? d.data().gender === 1
                              ? "남"
                              : "여"
                            : "미상"
                        },
                        {
                          id: 'age',
                          Header: "나이",
                          width: 100,
                          accessor: d => {
                            const { age, birthday: rawBirthday } = d.data();
                            if (rawBirthday) {
                              const birthday = rawBirthday.constructor.name !== "String"
                                ? moment(birthday?.toDate())
                                : moment(rawBirthday);
                              return `${moment().diff(birthday, 'years')}세`;
                            } else if (age) {
                              return `${age}세`;
                            } else {
                              return "미상";
                            }
                          }
                        },
                        {
                          id: 'email',
                          Header: "이메일 주소",
                          width: 300,
                          accessor: d => d.data().email
                        },
                        {
                          id: 'phone',
                          Header: "전화번호",
                          accessor: d => fromE164(d.data().phone)
                        },
                        {
                          id: 'orgName',
                          Header: "기관명",
                          accessor: d => {
                            const org_cd = d.data().org_cd;
                            const org = this.props.orgCodeMap && this.props.orgCodeMap[org_cd];
                            return org ? `${org.기관명}` : null;
                          }
                        },
                        {
                          id: 'org_cd',
                          Header: "기관코드",
                          accessor: d => {
                            const org_cd = d.data().org_cd;
                            return org_cd || null;
                          }
                        },
                        {
                          id: "created_at",
                          Header: "가입일시",
                          accessor: d => {
                            const created_at = d.data().created_at;
                            return moment(created_at ? created_at.toDate() : null).format('YYYY-MM-DD hh:mm:ss')
                          }
                        },
                        {
                          id: "updated_at",
                          Header: "갱신일시",
                          accessor: d => {
                            const created_at = d.data().created_at;
                            return moment(created_at ? created_at.toDate() : null).format('YYYY-MM-DD hh:mm:ss')
                          }
                        },
                        {
                          id: "status",
                          Header: "상태",
                          accessor: d => {
                            const { status = USER_STATUS.WAITING_FOR_REVIEW } = d.data();
                            return USER_STATUS_STRING[status];
                          }
                        },
                      ]}
                      getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                          return {
                            onClick: e => {
                              const d = rowInfo.original;
                              this.setState({
                                modalIsOpen: true,
                                selectedUserId: d.id,
                                isEdit: true,
                              });
                            },
                            style: {
                              cursor: 'pointer'
                            }
                          };
                        } else {
                          return {};
                        }
                      }}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {this.renderModal()}
      </Container>
    );
  }
}


UserManager.propTypes = {
  classes: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    users: state.user.users,
    orgCodeMap: state.org.orgCodeMap,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch);
}


export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(UserManager);